import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import styles from './download-margin-option.module.scss';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';

export function DownloadMarginOption(): ReactElement {
  const {margin, setMargin} = useDownloadPanelData();
  const onToggle = (): void => {
    setMargin(!margin);
  };

  return (
    <ContextualMenuToggleOption
      labelClassName={styles.label}
      isLabelBold
      toggleSize={ToggleSwitchV2Size.SMALL}
      onClick={onToggle}
      label={window.i18next.t('pmwjs_margin')}
      id="download-margin-option"
      isChecked={margin}
    />
  );
}
